/* =============================================================================
   Bennett & Vane — theme interactions (vanilla JS, no deps)
   Drawers and sheets, product options (colour + size), add to bag, the bag drawer,
   PDP gallery + zoom, quick add, Complete the look, recently viewed, search.
   Product data comes from Liquid, so there is no card generator here.
   ============================================================================= */
(function () {
  'use strict';

  var CFG = window.BV || {};
  var slice = function (list) { return [].slice.call(list); };

  /* Match Shopify's own money format (derived from a server-rendered sample) */
  var M_TPL = CFG.money || '$1,234.56';
  function money(cents) {
    var v = cents / 100;
    if (M_TPL.indexOf('1,234.56') > -1) return M_TPL.replace('1,234.56', v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    if (M_TPL.indexOf('1.234,56') > -1) return M_TPL.replace('1.234,56', v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    if (M_TPL.indexOf('1,235') > -1) return M_TPL.replace('1,235', Math.round(v).toLocaleString('en-US'));
    return '$' + v.toFixed(2);
  }

  /* ---------------------------------------------------------------------------
     Drawers (menu, bag, filters, search)
  --------------------------------------------------------------------------- */
  var overlay = function () { return document.querySelector('[data-overlay]'); };
  var opener = null;        /* what opened the bag, so focus can go back to it */
  var savingsSeen = false;  /* the saving counts up from $0 the first time the bag opens */
  function closeAll() {
    var bag = document.querySelector('#cart-drawer.is-open');
    document.querySelectorAll('.nav-drawer.is-open, .cart-drawer.is-open, .filter-drawer.is-open, .search-panel.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    var o = overlay(); if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
    if (bag && opener && document.contains(opener)) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    opener = null;
  }
  function open(id) {
    var map = { nav: '#nav-drawer', cart: '#cart-drawer', filter: '#filter-drawer', search: '#search-panel' };
    var el = document.querySelector(map[id]); if (!el) return;
    var already = el.classList.contains('is-open');
    /* one panel at a time: opening search from the menu closes the menu */
    document.querySelectorAll('.nav-drawer.is-open:not(.cart-drawer), .search-panel.is-open').forEach(function (d) { if (d !== el) d.classList.remove('is-open'); });
    el.classList.add('is-open');
    var o = overlay(); if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (id === 'search') {
      /* focus within the tap itself so phones bring the keyboard up, and once more when the panel has settled */
      var si = el.querySelector('[data-search-input]');
      if (si) { try { si.focus({ preventScroll: true }); } catch (e) { si.focus(); } setTimeout(function () { if (el.classList.contains('is-open') && document.activeElement !== si) si.focus(); }, 260); }
      el.dispatchEvent(new CustomEvent('bv:search-open'));
    }
    if (id === 'cart' && !already) {
      if (!opener) opener = document.activeElement;
      setTimeout(function () { var c = el.querySelector('[data-close]'); if (c && el.classList.contains('is-open')) c.focus({ preventScroll: true }); }, 80);
      var sv = el.querySelector('[data-savings]');
      if (sv && !savingsSeen) { savingsSeen = true; countUp(sv.querySelector('[data-savings-amount]'), 0, +sv.getAttribute('data-cents')); }
    }
  }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-open]');
    if (op) { e.preventDefault(); if (op.getAttribute('data-open') === 'cart') opener = op; open(op.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target.matches('[data-overlay]')) closeAll();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (!document.querySelector('dialog[open]')) closeAll(); return; }
    /* Tab stays inside the open bag */
    if (e.key !== 'Tab' || document.querySelector('dialog[open]')) return;
    var bag = document.querySelector('#cart-drawer.is-open'); if (!bag) return;
    var f = slice(bag.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]), [tabindex]:not([tabindex="-1"])')).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], cur = document.activeElement;
    if (!bag.contains(cur)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------------------------------------------------------------------
     Sheets (native <dialog>): size guide, quick add, photo zoom.
     A tap on the backdrop or a [data-sheet-close] button closes them.
  --------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var so = e.target.closest('[data-size-open]');
    if (so) { e.preventDefault(); var d = document.getElementById('size-guide-modal'); if (d && d.showModal && !d.open) d.showModal(); return; }
    var sc = e.target.closest('[data-sheet-close]');
    if (sc) { var dlg = sc.closest('dialog'); if (dlg) dlg.close(); return; }
    if (e.target.tagName === 'DIALOG' && (e.target.classList.contains('sheet') || e.target.classList.contains('lightbox'))) e.target.close();
  });

  /* Size chart: inches / centimetres */
  document.addEventListener('click', function (e) {
    var u = e.target.closest('[data-unit]'); if (!u) return;
    var chart = u.closest('[data-size-chart]'); if (!chart) return;
    var cm = u.getAttribute('data-unit') === 'cm';
    chart.querySelectorAll('[data-unit]').forEach(function (b) { var on = b === u; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    chart.querySelectorAll('[data-in]').forEach(function (s) { s.hidden = cm; });
    chart.querySelectorAll('[data-cm]').forEach(function (s) { s.hidden = !cm; });
  });

  /* Tabs (cosmetic) */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.tab'); if (!tab) return;
    var group = tab.closest('.tabs'); if (!group) return;
    group.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('is-active'); });
    tab.classList.add('is-active');
  });

  /* Exclusive accordions — only one <details> open per .accordion group */
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!item.matches || !item.matches('.accordion__item') || !item.open) return;
    var group = item.closest('.accordion'); if (!group) return;
    group.querySelectorAll('.accordion__item[open]').forEach(function (d) { if (d !== item) d.open = false; });
  }, true);

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty__btn'); if (!btn) return;
    var input = btn.parentElement.querySelector('.qty__input'); if (!input) return;
    var v = parseInt(input.value || '1', 10);
    v += (btn.textContent.trim() === '+' ? 1 : -1);
    input.value = Math.max(1, v);
    if (input.form) input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------------------------
     PDP gallery — swipeable, with a "1 / 8" counter, thumbnails, and tap to zoom.
     Photos past the second one load as they come near instead of all at once.
  --------------------------------------------------------------------------- */
  var galleryApi = null;
  function gallery() {
    var stage = document.querySelector('[data-gallery-stage]'); if (!stage) return;
    var slides = slice(stage.querySelectorAll('.pdp__slide'));
    var thumbs = slice(document.querySelectorAll('.pdp__thumbs [data-thumb]'));
    var count = document.querySelector('[data-gallery-count]');
    function hydrate(slide, lazy) {
      var im = slide && slide.querySelector('img[data-srcset]'); if (!im) return;
      im.loading = lazy ? 'lazy' : 'eager'; im.srcset = im.getAttribute('data-srcset'); im.src = im.getAttribute('data-src');
      im.removeAttribute('data-srcset'); im.removeAttribute('data-src');
    }
    function setActive(i) {
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
      if (count) count.textContent = i + 1;
      hydrate(slides[i]); hydrate(slides[i + 1]);
    }
    var wide = window.matchMedia ? matchMedia('(min-width: 990px)') : { matches: false };
    function goTo(i) { var s = slides[i]; if (!s) return; hydrate(s); stage.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }
    galleryApi = {
      /* Phones: swipe to that colour's photo. Desktop grid: bring it to the front of the grid. */
      goToMedia: function (id) {
        if (!id) return;
        for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === String(id)) {
          slides.forEach(function (s, n) { s.classList.toggle('is-lead', n === i && i > 0); });
          hydrate(slides[i]);
          if (wide.matches) { var r = stage.getBoundingClientRect(); if (r.top < 0) window.scrollTo({ top: window.scrollY + r.top - 120, behavior: 'smooth' }); }
          else { goTo(i); setActive(i); }
          return;
        }
      }
    };
    if ('IntersectionObserver' in window) {
      /* The carousel loads a photo when it is one swipe away; the desktop grid, one screen away.
         None of them start until the main photo is in, so nothing competes with the page's largest image:
         the desktop grid follows straight after it, the phone carousel once the page has finished loading
         (or at the first touch, whichever comes first). */
      var watching = false;
      var watch = function () {
        if (watching) return; watching = true;
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (!en.isIntersecting) return;
            /* desktop grid: a photo still below the screen is left to the browser's own lazy loading */
            var r = en.boundingClientRect;
            hydrate(en.target, wide.matches && !(r.top < window.innerHeight && r.bottom > 0));
            io.unobserve(en.target);
          });
        }, wide.matches ? { rootMargin: '700px 0px' } : { root: stage, rootMargin: '0px 99% 0px 99%' });
        slides.forEach(function (s) { if (s.querySelector('img[data-srcset]')) io.observe(s); });
      };
      var lead = slides[0] && slides[0].querySelector('img');
      if (wide.matches) {
        if (!lead || lead.complete) watch();
        else { lead.addEventListener('load', watch, { once: true }); lead.addEventListener('error', watch, { once: true }); }
      } else {
        whenIdle(watch);
        ['touchstart', 'pointerdown', 'scroll'].forEach(function (ev) { stage.addEventListener(ev, watch, { passive: true, once: true }); });
      }
      /* Videos play muted while on screen and pause when they leave */
      var vids = slice(stage.querySelectorAll('.pdp__slide--video video'));
      if (vids.length) {
        var vio = new IntersectionObserver(function (es) {
          es.forEach(function (en) { var v = en.target; if (en.intersectionRatio >= 0.6) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        }, { threshold: [0, 0.6] });
        vids.forEach(function (v) { vio.observe(v); });
      }
    } else { slides.forEach(hydrate); }
    var more = document.querySelector('[data-gallery-more]');
    if (more) more.addEventListener('click', function () { stage.classList.add('is-all'); more.hidden = true; });
    if (slides.length > 1) {
      thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = +t.getAttribute('data-thumb'); goTo(i); setActive(i); }); });
      var raf;
      stage.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = stage.clientWidth; if (!w) return;
          setActive(Math.max(0, Math.min(slides.length - 1, Math.round(stage.scrollLeft / w))));
        });
      }, { passive: true });
    }

    /* Tap a photo to open it full screen; tap again to zoom in and pan */
    var box = null;
    function openZoom(start) {
      if (!box) {
        box = document.createElement('dialog'); box.className = 'lightbox'; box.setAttribute('aria-label', 'Product photos');
        box.innerHTML = '<div class="lightbox__track"></div><span class="lightbox__count"></span>' +
          '<button type="button" class="lightbox__nav lightbox__nav--prev" data-zoom-step="-1" aria-label="Previous photo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>' +
          '<button type="button" class="lightbox__nav lightbox__nav--next" data-zoom-step="1" aria-label="Next photo"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>' +
          '<button type="button" class="lightbox__close" data-sheet-close aria-label="Close photos"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
        var track = box.firstChild, counter = box.querySelector('.lightbox__count');
        slides.forEach(function (s) {
          var z = s.querySelector('[data-zoom]'), small = s.querySelector('img'); if (!z) return;
          var f = document.createElement('figure'); f.className = 'lightbox__slide';
          var im = new Image(); im.alt = small ? small.alt : ''; im.setAttribute('data-src', z.getAttribute('data-zoom-src'));
          f.appendChild(im); track.appendChild(f);
        });
        var figs = slice(track.children);
        var load = function (i) { [i - 1, i, i + 1].forEach(function (n) { var im = figs[n] && figs[n].querySelector('img[data-src]'); if (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); } }); };
        var at = 0;
        var show = function (i) { at = i; counter.textContent = (i + 1) + ' / ' + figs.length; load(i); };
        var step = function (d) { var n = Math.max(0, Math.min(figs.length - 1, at + d)); figs.forEach(function (x) { x.classList.remove('is-zoomed'); }); track.classList.remove('is-locked'); track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); show(n); };
        box.addEventListener('click', function (e) { var b = e.target.closest('[data-zoom-step]'); if (b) step(+b.getAttribute('data-zoom-step')); });
        box.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); step(1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); } });
        if (figs.length < 2) slice(box.querySelectorAll('.lightbox__nav')).forEach(function (b) { b.hidden = true; });
        var zr;
        track.addEventListener('scroll', function () {
          if (zr) cancelAnimationFrame(zr);
          zr = requestAnimationFrame(function () { show(Math.round(track.scrollLeft / track.clientWidth)); });
        }, { passive: true });
        track.addEventListener('click', function (e) {
          var f = e.target.closest('.lightbox__slide'); if (!f) return;
          var on = !f.classList.contains('is-zoomed');
          figs.forEach(function (x) { x.classList.remove('is-zoomed'); x.scrollTop = 0; x.scrollLeft = 0; });
          f.classList.toggle('is-zoomed', on); track.classList.toggle('is-locked', on);
          if (on) { f.scrollLeft = (f.scrollWidth - f.clientWidth) / 2; f.scrollTop = (f.scrollHeight - f.clientHeight) / 3; }
        });
        box.addEventListener('close', function () { figs.forEach(function (x) { x.classList.remove('is-zoomed'); }); track.classList.remove('is-locked'); });
        box._go = function (i) { show(i); track.scrollTo({ left: i * track.clientWidth, behavior: 'auto' }); };
        document.body.appendChild(box);
      }
      box.showModal(); box._go(start);
    }
    stage.addEventListener('click', function (e) {
      var z = e.target.closest('[data-zoom]'); if (!z || !window.HTMLDialogElement) return;
      openZoom(+z.getAttribute('data-zoom'));
    });
  }

  /* Carousel nav */
  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-carousel-prev]');
    var next = e.target.closest('[data-carousel-next]');
    if (!prev && !next) return;
    var wrap = (prev || next).closest('.carousel');
    var track = wrap && wrap.querySelector('.carousel__track'); if (!track) return;
    var first = track.firstElementChild;
    var step = first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    track.scrollBy({ left: (next ? 1 : -1) * step * 2, behavior: 'smooth' });
  });

  /* Run fn once el is within `margin` of the viewport (or straight away without IntersectionObserver) */
  function whenNear(el, margin, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) { if (es.some(function (en) { return en.isIntersecting; })) { io.disconnect(); fn(); } }, { rootMargin: margin });
    io.observe(el);
  }

  /* The header goes compact once the page has moved: a marker at the very top of the page is watched,
     so nothing runs while scrolling */
  function headerScroll() {
    var h = document.querySelector('[data-header]'); if (!h) return;
    if (!('IntersectionObserver' in window)) return;
    var mark = document.createElement('div');
    mark.setAttribute('aria-hidden', 'true');
    mark.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:5px;pointer-events:none;visibility:hidden';
    document.body.appendChild(mark);
    new IntersectionObserver(function (es) { h.classList.toggle('is-scrolled', !es[es.length - 1].isIntersecting); }).observe(mark);
  }

  function stickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]'); if (!bar) return;
    var main = document.querySelector('.buybox [data-add]');
    if (!main || !('IntersectionObserver' in window)) { return; }
    var mainAbove = false, footerVisible = false;
    function apply() { bar.classList.toggle('is-visible', mainAbove && !footerVisible); }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { mainAbove = !e.isIntersecting && e.boundingClientRect.top < 0; });
      apply();
    }, { threshold: 0 }).observe(main);
    var footer = document.querySelector('.footer');
    if (footer) new IntersectionObserver(function (es) {
      es.forEach(function (e) { footerVisible = e.isIntersecting; });
      apply();
    }, { threshold: 0 }).observe(footer);
  }

  /* ---------------------------------------------------------------------------
     Product options — colour swatches + size buttons (snippets/product-options.liquid).
     One controller per [data-po]; it works out the variant, crosses out what is sold
     out, and refuses to hand back a variant until every option has been chosen.
  --------------------------------------------------------------------------- */
  function initOptions(root) {
    if (!root) return null;
    if (root.__po) return root.__po;
    var dataEl = root.querySelector('[data-po-variants]'); if (!dataEl) return null;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var groups = slice(root.querySelectorAll('[data-po-group]'));
    var idEl = root.querySelector('[data-po-id]');
    var nOpts = variants.length ? variants[0].o.length : 0;
    var gi = function (g) { return +g.getAttribute('data-po-group'); };
    function chosen() {
      var o = []; for (var i = 0; i < nOpts; i++) o[i] = groups.length ? null : variants[0].o[i];
      groups.forEach(function (g) { var r = g.querySelector('input:checked'); o[gi(g)] = r ? r.value : null; });
      return o;
    }
    function fits(v, o, skip) { return v.o.every(function (x, i) { return i === skip || o[i] == null || o[i] === x; }); }
    function setError(g, on) { var er = g.querySelector('[data-po-error]'); if (er) er.hidden = !on; g.classList.toggle('has-error', on); }
    var api = { root: root, variants: variants, state: {} };

    function refresh(changed) {
      var o = chosen();
      /* A size that doesn't exist in the newly chosen colour is cleared, never silently swapped */
      if (changed != null) groups.forEach(function (g) {
        var i = gi(g); if (i === changed || o[i] == null) return;
        if (!variants.some(function (v) { return fits(v, o, -1); })) { var r = g.querySelector('input:checked'); if (r) r.checked = false; o[i] = null; }
      });
      groups.forEach(function (g) {
        var i = gi(g), isColor = g.getAttribute('data-po-name') === 'color';
        slice(g.querySelectorAll('input')).forEach(function (inp) {
          var exists = false, avail = false;
          variants.forEach(function (v) {
            if (v.o[i] !== inp.value) return;
            /* A colour is judged on its own; a size is judged within the chosen colour */
            if (!isColor && !fits(v, o, i)) return;
            exists = true; if (v.a) avail = true;
          });
          var lab = inp.closest('label');
          lab.classList.toggle('is-unavailable', !avail);
          lab.classList.toggle('is-selected', inp.checked);
          inp.disabled = !exists;
        });
        var val = g.querySelector('[data-po-value]'); if (val) val.textContent = o[i] || '';
        if (o[i] != null) setError(g, false);
      });
      var complete = o.every(function (x) { return x != null; });
      var exact = complete ? variants.filter(function (v) { return fits(v, o, -1); })[0] : null;
      var matches = variants.filter(function (v) { return fits(v, o, -1); });
      var preview = exact || matches.filter(function (v) { return v.a; })[0] || matches[0] || variants[0];
      if (idEl) idEl.value = exact ? exact.id : '';
      api.state = { options: o, complete: complete, variant: exact || null, preview: preview };
      var changedName = null;
      groups.forEach(function (g) { if (gi(g) === changed) changedName = g.getAttribute('data-po-name'); });
      root.dispatchEvent(new CustomEvent('po:change', { bubbles: true, detail: { changed: changedName, variant: exact || null, preview: preview, complete: complete } }));
    }

    /* Returns the chosen variant, or shows what is missing and returns null */
    api.validate = function () {
      var o = chosen(), bad = null;
      groups.forEach(function (g) { var miss = o[gi(g)] == null; setError(g, miss); if (miss && !bad) bad = g; });
      groups.forEach(function (g) { var fold = g.querySelector('.po__fold'); if (fold && o[gi(g)] == null) fold.open = true; });
      if (bad) {
        var r = bad.getBoundingClientRect();
        if (r.top < 100 || r.bottom > window.innerHeight - 100) bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
        bad.classList.remove('is-nudged'); void bad.offsetWidth; bad.classList.add('is-nudged');
        return null;
      }
      var v = api.state.variant;
      return v && v.a ? v : null;
    };

    /* Choose a value from code. No DOM event is sent, so nothing else on the page (tracking scripts
       included) treats it as the shopper changing a form field. */
    api.set = function (i, value) {
      var g = groups.filter(function (x) { return gi(x) === i; })[0]; if (!g) return;
      var hit = slice(g.querySelectorAll('input')).filter(function (inp) { return inp.value === value && !inp.disabled; })[0];
      if (!hit || hit.checked) return;
      hit.checked = true; refresh(i);
    };

    root.addEventListener('change', function (e) {
      if (!e.target.matches('input[type=radio]')) return;
      var g = e.target.closest('[data-po-group]'); refresh(g ? gi(g) : null);
      var fold = g && g.querySelector('.po__fold'); if (fold) fold.open = false;
    });
    root.__po = api;
    refresh(null);
    return api;
  }

  /* A swatch is a square crop of the colour's photo; this gives the same photo uncropped at `width` */
  function uncropped(src, width) {
    try { var u = new URL(src, location.href); u.searchParams.delete('crop'); u.searchParams.delete('height'); u.searchParams.set('width', width); return u.toString(); }
    catch (e) { return src; }
  }
  function setPrices(scope, prefix, v) {
    if (!v) return;
    var sale = v.c > v.p;
    scope.querySelectorAll('[data-' + prefix + '-price]').forEach(function (el) { el.textContent = money(v.p); });
    scope.querySelectorAll('[data-' + prefix + '-compare]').forEach(function (el) { el.hidden = !sale; if (sale) el.textContent = money(v.c); });
    scope.querySelectorAll('[data-' + prefix + '-save]').forEach(function (el) { el.hidden = !sale; if (sale) el.textContent = 'Save ' + Math.floor((v.c - v.p) * 100 / v.c) + '%'; });
  }
  function setAddState(btns, d) {
    var missing = d.complete && !d.variant, sold = d.complete && d.variant && !d.variant.a;
    btns.forEach(function (b) {
      if (b.hasAttribute('data-sold-out')) return;
      b.disabled = !!(missing || sold);
      var lbl = b.querySelector('.js-add-label'); if (lbl) lbl.textContent = sold ? 'Sold out' : missing ? 'Unavailable' : 'Add to bag';
    });
  }
  function lookTotal(look) {
    if (!look) return;
    var sum = 0, n = 0;
    look.querySelectorAll('[data-look-item]').forEach(function (it) {
      var inc = it.querySelector('[data-look-include]'), on = !inc || inc.checked;
      it.classList.toggle('is-off', !on);
      var po = initOptions(it.querySelector('[data-po]'));
      if (on && po && po.state.preview) { sum += po.state.preview.p; n++; }
    });
    var hit = tierFor(bagCount() + n), pct = hit && n ? hit[1] : 0;
    var total = Math.round(sum * (100 - pct) / 100);
    var t = look.querySelector('[data-look-total]'); if (t) t.textContent = money(total);
    var was = look.querySelector('[data-look-was]'); if (was) { was.hidden = !pct; was.textContent = money(sum); }
    var sv = look.querySelector('[data-look-saving]'); if (sv) { sv.hidden = !pct; sv.textContent = 'You save ' + money(sum - total) + ' with ' + pct + '% multi-buy'; }
    var b = look.querySelector('[data-add]'); if (b) b.disabled = n === 0;
  }

  document.addEventListener('po:change', function (e) {
    var d = e.detail, root = e.target;
    /* A message about the last attempt ("… is sold out") no longer applies once the choice changes */
    if (d.changed != null) {
      var holder = root.closest('[data-add-form], [data-look-form]'), stale = holder && holder.querySelector('[data-add-error]');
      if (stale) stale.hidden = true;
    }
    var item = root.closest('[data-look-item]');
    if (item) {
      setPrices(item, 'po', d.preview); lookTotal(item.closest('[data-look]'));
      var chip = root.querySelector('.po-swatch.is-selected img'), lt = item.querySelector('[data-look-thumb]');
      if (d.changed === 'color' && chip && lt) lt.src = uncropped(chip.src, 240);
      return;
    }
    var qa = root.closest('[data-qa]');
    if (qa) { setPrices(qa, 'po', d.preview); setAddState(slice(qa.querySelectorAll('[data-add]')), d); return; }
    if (root.closest('#product-form')) pdpChange(d);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches) return;
    if (e.target.matches('[data-look-include]')) lookTotal(e.target.closest('[data-look]'));
    /* Once the shopper picks inside the "this piece" row, it stops following the main selection */
    var cur = e.isTrusted && e.target.closest('[data-look-current]'); if (cur) cur.__touched = true;
  });
  /* The "this piece" row of Complete the look follows the colour and size chosen at the top of the page */
  function syncLookCurrent(v) {
    var row = document.querySelector('[data-look-current]'); if (!row || row.__touched || !v) return;
    var po = initOptions(row.querySelector('[data-po]')); if (!po) return;
    v.o.forEach(function (want, i) { po.set(i, want); });
  }
  /* Run fn after the browser has painted, so a tap shows its result before the follow-up work starts */
  function afterPaint(fn) { requestAnimationFrame(function () { setTimeout(fn, 0); }); }

  /* Product page: price, sale saving, button, stock line, gallery and URL follow the selection */
  function pdpChange(d) {
    var v = d.preview;
    setPrices(document, 'pdp', v);
    setAddState(slice(document.querySelectorAll('#product-form [data-add], [data-add][form="product-form"]')), d);
    var stock = document.querySelector('[data-pdp-stock]');
    if (stock) {
      var low = d.variant && d.variant.a && d.variant.q > 0 && d.variant.q <= 6;
      stock.hidden = !low;
      if (low) stock.querySelector('[data-pdp-stock-text]').textContent = 'Only ' + d.variant.q + ' left';
    }
    if (d.changed === 'color' && galleryApi) {
      galleryApi.goToMedia(v.m);
      var chip = document.querySelector('#product-form .po-swatch.is-selected img'), thumb = document.querySelector('[data-pdp-thumb]');
      if (chip && thumb) thumb.src = uncropped(chip.src, 120);
    }
    /* What the shopper is looking at has changed by now; the rest (the "this piece" row further down
       and the address bar) follows once that has been painted */
    if (d.variant) afterPaint(function () {
      syncLookCurrent(d.variant);
      if (d.changed != null && window.history && history.replaceState) {
        try { var u = new URL(location.href); u.searchParams.set('variant', d.variant.id); history.replaceState(history.state, '', u.toString()); } catch (err) {}
      }
    });
  }

  /* ---------------------------------------------------------------------------
     Bag — add to bag opens the side drawer, and qty/remove inside it update in
     place via the Section Rendering API.
  --------------------------------------------------------------------------- */
  /* Multi-buy tiers come from Theme settings → Store facts as [[items, percent], …] (snippets/fact-tiers) */
  var TIERS = CFG.tiers || [];
  function tierFor(n) { var best = null; TIERS.forEach(function (t) { if (n >= t[0]) best = t; }); return best; }
  function bagCount() { var d = document.querySelector('#cart-drawer'); return d ? parseInt(d.getAttribute('data-cart-count') || '0', 10) || 0 : 0; }
  /* The product page card: which tier adding this item reaches, in the same words as the Liquid */
  function syncTiers(n) {
    if (!TIERS.length) return;
    var hit = tierFor(n + 1), text;
    if (hit) text = 'Add this to your bag and save ' + hit[1] + '% on your order. Applied automatically at checkout.';
    else { var need = TIERS[0][0] - (n + 1); text = 'Add this plus ' + need + ' more item' + (need === 1 ? '' : 's') + ' to save ' + TIERS[0][1] + '%. Applied automatically at checkout.'; }
    document.querySelectorAll('[data-tier-card]').forEach(function (card) {
      card.querySelectorAll('[data-tier]').forEach(function (li) { li.classList.toggle('is-next', !!hit && +li.getAttribute('data-tier') === hit[0]); });
      var note = card.querySelector('[data-tier-note]'); if (note) note.textContent = text;
    });
    document.querySelectorAll('[data-look]').forEach(lookTotal);
  }
  function updateCartCount(n) {
    syncTiers(n);
    var btn = document.querySelector('.header__cart'); if (!btn) return;
    var badge = btn.querySelector('.header__count');
    if (n > 0) { if (!badge) { badge = document.createElement('span'); badge.className = 'header__count'; btn.appendChild(badge); } badge.textContent = n; }
    else if (badge) { badge.remove(); }
  }

  var reducedMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Count a money figure from one amount to another (the bag's saving) */
  function countUp(el, from, to) {
    if (!el) return;
    if (reducedMotion || from === to) { el.textContent = money(to); return; }
    var t0 = null;
    requestAnimationFrame(function step(now) {
      if (t0 === null) t0 = now;
      var k = Math.min(1, (now - t0) / 600), ease = 1 - Math.pow(1 - k, 3);
      el.textContent = money(Math.round(from + (to - from) * ease));
      if (k < 1) requestAnimationFrame(step);
    });
  }
  /* What the bag showed before a re-render, so the bar and the saving can move from there */
  function bagState(scope) {
    var fill = scope && scope.querySelector('.sc-progress__fill'), sv = scope && scope.querySelector('[data-savings]');
    return { fill: fill ? fill.style.getPropertyValue('--p') : null, saving: sv ? +sv.getAttribute('data-cents') : 0 };
  }
  function animateBag(scope, prev, visible) {
    var fill = scope.querySelector('.sc-progress__fill');
    if (fill && prev.fill != null && !reducedMotion) {
      var to = fill.style.getPropertyValue('--p');
      fill.style.transition = 'none'; fill.style.setProperty('--p', prev.fill); void fill.offsetWidth;
      fill.style.transition = ''; fill.style.setProperty('--p', to);
    }
    var sv = scope.querySelector('[data-savings]'); if (!sv || !visible) return;
    var now = +sv.getAttribute('data-cents');
    savingsSeen = true;
    countUp(sv.querySelector('[data-savings-amount]'), prev.saving, now);
    if (now > prev.saving && !reducedMotion) { sv.classList.remove('is-pulse'); void sv.offsetWidth; sv.classList.add('is-pulse'); }
  }
  /* Which control had focus, so it can have it again after the bag is re-rendered */
  function focusKey(scope) {
    var el = document.activeElement; if (!el || !scope.contains(el)) return null;
    if (el.hasAttribute('data-qty-dir')) return '[data-line="' + el.getAttribute('data-line') + '"][data-qty-dir="' + el.getAttribute('data-qty-dir') + '"]';
    if (el.hasAttribute('data-checkout')) return '[data-checkout]';
    return '[data-close]';
  }
  function parse(html, selector) { var tmp = document.createElement('div'); tmp.innerHTML = (html || '').trim(); return tmp.querySelector(selector); }

  /* Swap in freshly rendered bag markup: the side cart, and the cart page when it is on screen */
  function renderCart(sections) {
    if (!sections) return;
    var cur = document.querySelector('#cart-drawer'), fresh = parse(sections['cart-drawer'], '#cart-drawer');
    if (cur && fresh) {
      var isOpen = cur.classList.contains('is-open'), prev = bagState(cur), key = isOpen ? focusKey(cur) : null;
      var body = cur.querySelector('.sc__body'), top = body ? body.scrollTop : 0;
      if (isOpen) fresh.classList.add('is-open');
      cur.replaceWith(fresh);
      var nb = fresh.querySelector('.sc__body'); if (nb) nb.scrollTop = top;
      animateBag(fresh, prev, isOpen);
      if (key) { var again = fresh.querySelector(key) || fresh.querySelector('[data-close]'); if (again) again.focus({ preventScroll: true }); }
      updateCartCount(parseInt(fresh.getAttribute('data-cart-count') || '0', 10));
    }
    var page = document.querySelector('[data-main-cart]'), freshPage = parse(sections['main-cart'], '[data-main-cart]');
    if (page && freshPage) {
      var prevPage = bagState(page), pageKey = focusKey(page);
      page.innerHTML = freshPage.innerHTML;
      animateBag(page, prevPage, true);
      if (pageKey && pageKey !== '[data-close]') { var pa = page.querySelector(pageKey); if (pa) pa.focus({ preventScroll: true }); }
    }
  }
  function cartSections() { return document.querySelector('[data-main-cart]') ? ['cart-drawer', 'main-cart'] : ['cart-drawer']; }
  function refreshCart() {
    return fetch('/?sections=' + cartSections().join(','), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  /* Resolves with { ok, data }; a network failure rejects */
  function cartPost(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }, function () { return { ok: false, data: null }; }); });
  }

  /* Add to bag is one round trip: the button shows its loading state, the response carries the
     freshly rendered bag, and the bag opens with the item already in it. */
  var ADD_FAILED = "Sorry, we couldn't add that to your bag. Please try again.";
  function addToBag(items, form) {
    var btns = slice(form.querySelectorAll('[data-add]'));
    if (form.id) btns = btns.concat(slice(document.querySelectorAll('[data-add][form="' + form.id + '"]')));
    if (btns.some(function (b) { return b.classList.contains('is-loading'); })) return Promise.resolve();
    var errEl = form.querySelector('[data-add-error]'); if (errEl) errEl.hidden = true;
    var sheet = form.closest('dialog');
    if (!document.querySelector('#cart-drawer.is-open')) opener = document.activeElement;
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    return cartPost('/cart/add.js', { items: items, sections: cartSections(), sections_url: location.pathname })
      .then(function (res) {
        if (!res.ok || !res.data) throw res;
        if (sheet && sheet.open) sheet.close();
        if (res.data.sections && res.data.sections['cart-drawer']) renderCart(res.data.sections);
        open('cart');
        if (!(res.data.sections && res.data.sections['cart-drawer'])) refreshCart();
        btns.forEach(function (b) { b.classList.add('is-added'); setTimeout(function () { b.classList.remove('is-added'); }, 1600); });
      })
      .catch(function (res) {
        var msg = res && res.data && (res.data.description || res.data.message);
        if (typeof msg !== 'string' || !msg) msg = ADD_FAILED;
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      })
      .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
  }

  /* Add to bag: the product page form (and its sticky bar, via form=), the quick-add sheet,
     and Complete the look. Nothing is added until every option has been chosen. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (form) {
      e.preventDefault();
      var po = initOptions(form.querySelector('[data-po]'));
      var v = po ? po.validate() : null;
      if (v) addToBag([{ id: v.id, quantity: 1 }], form);
      return;
    }
    var look = e.target.closest('[data-look-form]');
    if (look) {
      e.preventDefault();
      var items = [], ok = true;
      look.querySelectorAll('[data-look-item]').forEach(function (it) {
        var inc = it.querySelector('[data-look-include]'); if (inc && !inc.checked) return;
        var p = initOptions(it.querySelector('[data-po]')); var lv = p ? p.validate() : null;
        if (lv) items.push({ id: lv.id, quantity: 1 }); else ok = false;
      });
      if (ok && items.length) addToBag(items, look);
      return;
    }
    /* Check out: a pressed, loading button, and no double submits */
    var co = e.target.closest('[data-checkout-form]');
    if (co) {
      if (co.__going) { e.preventDefault(); return; }
      co.__going = true;
      var cb = co.querySelector('[data-checkout]'); if (cb) { cb.classList.add('is-loading'); cb.setAttribute('aria-busy', 'true'); }
    }
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-checkout-form]').forEach(function (f) { f.__going = false; var cb = f.querySelector('[data-checkout]'); if (cb) { cb.classList.remove('is-loading'); cb.removeAttribute('aria-busy'); } });
  });

  /* Quantity and remove, in the side cart and on the cart page. Only the line being changed
     looks busy, and taps are ignored while a change is on its way. */
  var cartBusy = false;
  document.addEventListener('click', function (e) {
    var ctl = e.target.closest('[data-line][data-change]'); if (!ctl) return;
    e.preventDefault();
    if (cartBusy) return;
    cartBusy = true;
    var line = ctl.closest('.sc-line'), msg = line && line.querySelector('[data-line-msg]');
    if (line) line.classList.add('is-busy');
    if (msg) msg.hidden = true;
    cartPost('/cart/change.js', { line: parseInt(ctl.getAttribute('data-line'), 10), quantity: parseInt(ctl.getAttribute('data-change'), 10), sections: cartSections(), sections_url: location.pathname })
      .then(function (res) {
        if (res.ok && res.data && res.data.sections) { renderCart(res.data.sections); return; }
        var text = res.data && (res.data.description || res.data.message);
        if (line) line.classList.remove('is-busy');
        if (msg && typeof text === 'string' && text) { msg.textContent = text; msg.hidden = false; } else return refreshCart();
      })
      .catch(function () { if (line) line.classList.remove('is-busy'); return refreshCart(); })
      .then(function () { cartBusy = false; });
  });

  /* ---------------------------------------------------------------------------
     Quick add — the "+" on a product card or a bag add-on opens the colour and
     size picker in a sheet (sections/quick-add.liquid, fetched on demand).
  --------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]'); if (!b) return;
    var sheet = document.getElementById('quick-add-sheet'); if (!sheet || !sheet.showModal) return;
    e.preventDefault();
    var url = b.getAttribute('data-quick-add');
    var body = sheet.querySelector('[data-sheet-body]');
    body.innerHTML = '<div class="sheet__loading" role="status"><span class="visually-hidden">Loading</span></div>';
    if (!sheet.open) sheet.showModal();
    fetch(url + '?section_id=quick-add')
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var qa = tmp.querySelector('[data-qa]'); if (!qa) throw 0;
        body.innerHTML = ''; body.appendChild(qa);
        initOptions(qa.querySelector('[data-po]'));
      })
      .catch(function () { location.href = url; });
  });

  /* Complete the look — only when the store has set complementary products */
  function completeLook() {
    var el = document.querySelector('[data-complete-look]'); if (!el) return;
    whenNear(el, '900px 0px', function () {
      var url = el.getAttribute('data-url'), chosen = document.querySelector('#product-form [data-po-id]');
      if (chosen && chosen.value) url += '&variant=' + chosen.value;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var sec = tmp.querySelector('[data-look]'); if (!sec) return;
          el.replaceWith(sec);
          sec.querySelectorAll('[data-po]').forEach(initOptions);
          var main = document.querySelector('#product-form [data-po]');
          if (main && main.__po) syncLookCurrent(main.__po.state.variant);
          lookTotal(sec);
        })
        .catch(function () {});
    });
  }

  function whenIdle(fn) {
    var go = function () { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 3000 }); else setTimeout(fn, 1200); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }
  /* Styled with — complementary products, only for products without their own styled-with list */
  function styledWith() {
    var el = document.querySelector('[data-styled-with][data-url]'); if (!el) return;
    whenIdle(function () {
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var chips = tmp.querySelector('[data-styled-chips]'); if (!chips || !chips.children.length) return;
          var row = el.querySelector('[data-styled-row]');
          while (chips.firstElementChild) row.appendChild(chips.firstElementChild);
          el.hidden = false;
        })
        .catch(function () {});
    });
  }
  /* You may also like — Shopify's recommendations replace the collection fallback when there are enough */
  function productRecs() {
    var track = document.querySelector('[data-recs][data-url]'); if (!track) return;
    whenNear(track, '900px 0px', function () {
      fetch(track.getAttribute('data-url'))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var cards = slice(tmp.querySelectorAll('[data-recs-cards] .product-card')); if (cards.length < 4) return;
          track.innerHTML = ''; cards.forEach(function (c) { track.appendChild(c); });
          track.scrollLeft = 0; hoverImages();
        })
        .catch(function () {});
    });
  }

  /* Recently viewed — product ids live in this browser only */
  function recentlyViewed() {
    var el = document.querySelector('[data-recently-viewed]'); if (!el) return;
    var KEY = 'bv:recent', ids = [];
    try { ids = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { ids = []; }
    if (!Array.isArray(ids)) ids = [];
    var cur = el.getAttribute('data-product-id');
    var others = ids.filter(function (id) { return id !== cur && /^\d+$/.test(id); }).slice(0, 8);
    try { localStorage.setItem(KEY, JSON.stringify([cur].concat(others).slice(0, 12))); } catch (e) {}
    if (!others.length) return;
    whenNear(el, '900px 0px', function () {
      var q = others.map(function (id) { return 'id:' + id; }).join(' OR ');
      fetch(el.getAttribute('data-url') + '?section_id=recently-viewed&type=product&q=' + encodeURIComponent(q))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var sec = tmp.querySelector('section'); if (!sec) return;
          el.replaceWith(sec); hoverImages();
        })
        .catch(function () {});
    });
  }

  /* ---------------------------------------------------------------------------
     Search panel (sections/header.liquid). Before typing: recent searches (this browser only),
     the categories, and a few pieces fetched the first time the panel opens. While typing:
     suggested searches, matching collections and products from Shopify's predictive search.
  --------------------------------------------------------------------------- */
  function initSearch() {
    var panel = document.getElementById('search-panel'); if (!panel) return;
    var input = panel.querySelector('[data-search-input]');
    var live = panel.querySelector('[data-search-live]'), idle = panel.querySelector('[data-search-idle]');
    var clearBtn = panel.querySelector('[data-search-clear]');
    if (!input || !live || !idle) return;
    var timer, controller, last = '', RECENT = 'bv:searches';
    var SEARCH_ICON = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/></svg>';
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function cents(p) { var n = parseFloat(String(p == null ? '' : p).replace(/,/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
    /* the typed words, picked out in a result */
    function mark(text, q) {
      var safe = esc(text), words = q.split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
      if (!words.length) return safe;
      try { return safe.replace(new RegExp('(' + words.join('|') + ')', 'ig'), '<mark>$1</mark>'); } catch (e) { return safe; }
    }
    function withType(url) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'type=product'; }

    /* recent searches */
    function recent() { try { var a = JSON.parse(localStorage.getItem(RECENT) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string' && x; }).slice(0, 5) : []; } catch (e) { return []; } }
    function remember(q) {
      q = String(q || '').trim().slice(0, 60); if (q.length < 2) return;
      try { var a = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); a.unshift(q); localStorage.setItem(RECENT, JSON.stringify(a.slice(0, 5))); } catch (e) {}
    }
    function drawRecent() {
      var box = panel.querySelector('[data-search-recent]'); if (!box) return;
      var a = recent(); box.hidden = !a.length;
      box.innerHTML = a.length ? '<div class="bvs__labelrow"><p class="bvs__label">Recent searches</p><button type="button" class="bvs__textbtn" data-search-forget>Clear</button></div><div class="bvs__chips">' +
        a.map(function (q) { return '<button type="button" class="bvs-chip bvs-chip--recent" data-search-term="' + esc(q) + '">' + esc(q) + '</button>'; }).join('') + '</div>' : '';
    }
    /* a few pieces under "Browse": asked for once, the first time the panel is opened */
    var picksAsked = false;
    function loadPicks() {
      if (picksAsked) return; picksAsked = true;
      var slot = panel.querySelector('[data-search-picks]'), url = panel.getAttribute('data-idle-url'); if (!slot || !url) return;
      fetch(url).then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (data) { var tmp = document.createElement('div'); tmp.innerHTML = (data && data['search-idle']) || ''; var c = tmp.querySelector('[data-search-idle-content]'); if (c) slot.innerHTML = c.innerHTML; })
        .catch(function () { picksAsked = false; });
    }
    function showIdle() { live.hidden = true; live.innerHTML = ''; live.classList.remove('is-loading'); idle.hidden = false; }

    function draw(q, res) {
      var products = res.products || [], queries = res.queries || [], colls = res.collections || [];
      live.classList.remove('is-loading');
      if (!products.length && !queries.length && !colls.length) {
        live.innerHTML = '<p class="bvs__none">No results for <strong>&ldquo;' + esc(q) + '&rdquo;</strong>. Check the spelling, or try a broader word.</p>';
        live.hidden = false; idle.hidden = false; return;
      }
      var side = '';
      if (queries.length) side += '<div class="bvs__group"><p class="bvs__label">Suggestions</p><div class="bvs__terms">' + queries.slice(0, 4).map(function (s) {
        return '<a class="bvs-term" href="' + esc(withType(s.url)) + '" data-search-save="' + esc(s.text) + '">' + SEARCH_ICON + '<span>' + mark(s.text, q) + '</span></a>';
      }).join('') + '</div></div>';
      if (colls.length) side += '<div class="bvs__group"><p class="bvs__label">Collections</p><div class="bvs__terms">' + colls.slice(0, 3).map(function (c) {
        return '<a class="bvs-term bvs-term--coll" href="' + esc(c.url) + '" data-search-save="' + esc(q) + '"><span>' + esc(c.title) + '</span></a>';
      }).join('') + '</div></div>';
      var list = products.map(function (p) {
        var bits = String(p.title || '').split('|'), name = bits[0].trim(), desc = bits.slice(1).join('|').trim();
        var lo = cents(p.price_min != null ? p.price_min : p.price), hi = cents(p.price_max), was = cents(p.compare_at_price_max);
        var price = lo != null ? (hi != null && hi > lo ? 'From ' : '') + money(lo) : '';
        var img = p.image ? '<img src="' + esc(uncropped(p.image, 320)) + '" alt="" width="320" height="400" loading="lazy" decoding="async">' : '';
        return '<a class="bvs-item" href="' + esc(p.url) + '" data-search-save="' + esc(q) + '"><span class="bvs-item__media">' + img + '</span>' +
          '<span class="bvs-item__text"><span class="bvs-item__name">' + mark(name, q) + '</span>' + (desc ? '<span class="bvs-item__sub">' + esc(desc) + '</span>' : '') + '</span>' +
          '<span class="bvs-item__price"><span>' + esc(price) + '</span>' + (was != null && lo != null && was > lo ? '<s>' + esc(money(was)) + '</s>' : '') + (p.available === false ? '<em>Sold out</em>' : '') + '</span></a>';
      }).join('');
      var main = products.length ? '<div class="bvs__main"><p class="bvs__label">Products</p><div class="bvs__list">' + list + '</div>' +
        '<a class="btn btn--secondary bvs__all" href="/search?q=' + encodeURIComponent(q) + '&type=product" data-search-save="' + esc(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a></div>' : '';
      live.innerHTML = '<div class="bvs__results' + (side && main ? '' : ' bvs__results--solo') + '">' + (side ? '<div class="bvs__side">' + side + '</div>' : '') + main + '</div>';
      live.hidden = false; idle.hidden = true;
    }
    function run(q) {
      if (window.AbortController) { if (controller) controller.abort(); controller = new AbortController(); }
      if (live.hidden || !live.firstChild) {
        live.innerHTML = '<p class="bvs__label">Products</p>' + new Array(4).join('<div class="bvs-skel"><i></i><b></b></div>');
        live.hidden = false; idle.hidden = true;
      } else live.classList.add('is-loading');
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last', controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) { if (input.value.trim() === q) draw(q, ((data || {}).resources || {}).results || {}); })
        .catch(function (e) { if (e && e.name === 'AbortError') return; if (input.value.trim() === q) draw(q, {}); });
    }
    function typed() {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = input.value.length === 0;
      if (q === last) return; last = q;
      clearTimeout(timer);
      if (q.length < 2) { if (controller) controller.abort(); showIdle(); return; }
      timer = setTimeout(function () { run(q); }, 160);
    }
    input.addEventListener('input', typed);
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; typed(); input.focus(); });
    if (input.form) input.form.addEventListener('submit', function (e) { var q = input.value.trim(); if (!q) { e.preventDefault(); return; } remember(q); });
    panel.addEventListener('click', function (e) {
      var term = e.target.closest('[data-search-term]');
      if (term) { input.value = term.getAttribute('data-search-term'); typed(); input.focus(); return; }
      if (e.target.closest('[data-search-forget]')) { try { localStorage.removeItem(RECENT); } catch (err) {} drawRecent(); return; }
      var save = e.target.closest('[data-search-save]'); if (save) remember(save.getAttribute('data-search-save'));
    });
    /* arrow keys walk through the results from the field */
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = slice(live.querySelectorAll('a')).filter(function (a) { return a.offsetParent !== null; }); if (!links.length) return;
      var at = links.indexOf(document.activeElement), next = e.key === 'ArrowDown' ? at + 1 : at - 1;
      e.preventDefault();
      if (next < 0) input.focus(); else if (next < links.length) links[next].focus();
    });
    panel.addEventListener('bv:search-open', function () { drawRecent(); loadPicks(); });
    /* a head start: the pieces are asked for as the finger or pointer comes down on a search button */
    document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('[data-open="search"]')) loadPicks(); }, { passive: true });
  }

  /* ---------------------------------------------------------------------------
     Shop page (a collection or search results): filters, sort and "Load more" happen in place
     through the Section Rendering API, the URL keeps up, and coming back from a product page
     lands where the shopper left off. Phones keep their filter drawer (applied in place by
     "Show results") and numbered pages.
  --------------------------------------------------------------------------- */
  function shop() {
    var root = document.querySelector('[data-shop]'); if (!root) return;
    window.BVshop = true;   /* the phone sort menu submits its form only when this script is not running */
    var sid = root.getAttribute('data-section'), busy = false, KEY = 'bv:shop:';
    var phone = window.matchMedia ? matchMedia('(max-width: 989px)') : { matches: false };
    var part = function (scope) {
      return { results: scope.querySelector('[data-shop-results]'), facets: slice(scope.querySelectorAll('[data-shop-facets]')), counts: slice(scope.querySelectorAll('[data-shop-count]')), sort: scope.querySelector('[data-shop-sort]'), mfacets: scope.querySelector('[data-shop-mfacets]') };
    };
    function go(url, append) {
      if (busy) return; busy = true;
      var u = new URL(url, location.href), f = new URL(u.href); f.searchParams.set('section_id', sid);
      root.classList.add('is-loading');
      fetch(f.href)
        .then(function (r) { if (!r.ok) throw r; return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-shop]'); if (!fresh) throw 0;
          var a = part(root), b = part(fresh);
          if (append) {
            var grid = a.results.querySelector('[data-shop-grid]'), more = a.results.querySelector('[data-shop-more]'), next = b.results.querySelector('[data-shop-more]');
            slice(b.results.querySelectorAll('[data-shop-grid] > *')).forEach(function (c) { grid.appendChild(c); });
            if (next) { var prev = next.querySelector('.shop-more__prev'); if (prev) prev.remove(); }
            if (more && next) more.replaceWith(next); else if (more) more.remove();
          } else {
            /* keep the open filter panel open and the focused control focused across the swap */
            var open = slice(root.querySelectorAll('[data-facet][open]')).map(function (d) { return d.getAttribute('data-facet'); });
            var el = document.activeElement, focus = el && root.contains(el) && el.name ? { name: el.name, value: el.type === 'checkbox' ? el.value : null } : null;
            a.results.innerHTML = b.results.innerHTML;
            a.facets.forEach(function (x, i) { if (b.facets[i]) x.innerHTML = b.facets[i].innerHTML; });
            a.counts.forEach(function (x, i) { if (b.counts[i]) x.textContent = b.counts[i].textContent; });
            if (a.sort && b.sort) a.sort.innerHTML = b.sort.innerHTML;
            if (a.mfacets && b.mfacets) a.mfacets.innerHTML = b.mfacets.innerHTML;
            /* phones: the new list starts at its top, not wherever the old one had been scrolled to */
            if (phone.matches) { var top = root.getBoundingClientRect().top; if (top < 0) window.scrollTo(0, window.scrollY + top); }
            slice(root.querySelectorAll('.facets--bar [data-facet]')).forEach(function (d) { d.open = open.indexOf(d.getAttribute('data-facet')) > -1; });
            if (focus) {
              var again = slice(root.querySelectorAll('[data-facets] [name="' + focus.name.replace(/"/g, '\\"') + '"]')).filter(function (x) { return focus.value == null || x.value === focus.value; })[0];
              if (again) again.focus({ preventScroll: true });
            }
          }
          history.replaceState(history.state, '', u.pathname + u.search);
          hoverImages();
        })
        .catch(function () { location.href = url; })
        .then(function () { busy = false; root.classList.remove('is-loading'); });
    }
    function applyFacets(form) {
      var params = new URLSearchParams(new FormData(form)), drop = [];
      params.forEach(function (v, k) { if (v === '') drop.push(k); });
      drop.forEach(function (k) { params.delete(k); });
      var q = params.toString(), action = form.getAttribute('action');
      go(action + (q ? (action.indexOf('?') > -1 ? '&' : '?') + q : ''));
    }
    root.addEventListener('change', function (e) {
      var form = e.target.closest('[data-facets]'); if (form) { applyFacets(form); return; }
      /* phones: the sort menu re-sorts in place, keeping the filters */
      if (e.target.matches && e.target.matches('[data-shop-sortselect]')) {
        var su = new URL(location.href); su.searchParams.set('sort_by', e.target.value); su.searchParams.delete('page');
        go(su.pathname + su.search);
      }
    });
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-facets]'); if (form) { e.preventDefault(); applyFacets(form); return; }
      /* phones: "Show results" in the filter drawer applies the filters in place and closes the drawer */
      var mform = e.target.closest('[data-shop-mform]'); if (mform) { e.preventDefault(); applyFacets(mform); closeAll(); }
    });
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-shop-link]');
      if (link) { e.preventDefault(); go(link.getAttribute('href')); if (link.hasAttribute('data-shop-done')) closeAll(); return; }
      var sort = e.target.closest('[data-sort]');
      if (sort) {
        e.preventDefault();
        var u = new URL(location.href); u.searchParams.set('sort_by', sort.getAttribute('data-sort')); u.searchParams.delete('page');
        var dd = sort.closest('details'); if (dd) dd.open = false;
        go(u.pathname + u.search); return;
      }
      var more = e.target.closest('[data-shop-more-link]');
      if (more) { e.preventDefault(); go(more.getAttribute('href'), true); }
    });
    /* One dropdown open at a time; a click elsewhere or Esc closes it */
    var drops = function () { return slice(root.querySelectorAll('.facets--bar [data-facet], [data-sortdd]')); };
    root.addEventListener('toggle', function (e) {
      var d = e.target; if (!d.open || !d.matches || !d.matches('.facets--bar [data-facet], [data-sortdd]')) return;
      drops().forEach(function (x) { if (x !== d) x.open = false; });
    }, true);
    document.addEventListener('click', function (e) { drops().forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      drops().forEach(function (d) { if (d.open) { d.open = false; var sm = d.querySelector('summary'); if (sm && d.contains(document.activeElement)) sm.focus(); } });
    });

    /* Back from a product page: the same pages loaded, at the same scroll position */
    var key = function () { return KEY + location.pathname + location.search; };
    window.addEventListener('pagehide', function () {
      var r = root.querySelector('[data-shop-results]'); if (!r) return;
      try { sessionStorage.setItem(key(), JSON.stringify({ html: r.innerHTML, y: window.scrollY, t: Date.now() })); } catch (e) {}
    });
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward') {
        var st = JSON.parse(sessionStorage.getItem(key()) || 'null'), res = root.querySelector('[data-shop-results]');
        if (st && res && Date.now() - st.t < 1800000) {
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
          res.innerHTML = st.html; hoverImages();
          requestAnimationFrame(function () { window.scrollTo(0, st.y); });
        }
      }
    } catch (e) {}
  }

  /* ---------------------------------------------------------------------------
     Product cards with a mouse: hovering shows the sizes, and clicking one adds that size
     straight to the bag; a colour dot switches the card to that colour's photo and sizes.
     Touch devices keep the "+" button and its size sheet.
  --------------------------------------------------------------------------- */
  function cards() {
    var mq = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    if (!mq || !mq.matches) return;
    var esc = function (t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var fileOf = function (src) { return String(src || '').split('?')[0].split('/').pop(); };
    function colorIndex(p) {
      for (var i = 0; i < p.options.length; i++) { var n = String(p.options[i].name || p.options[i]).toLowerCase(); if (n.indexOf('colo') > -1 || n === 'farbe' || n === 'couleur') return i; }
      return -1;
    }
    function build(card) {
      var p = card.__p, media = card.querySelector('.product-card__media'); if (!p || !media) return;
      var ci = colorIndex(p);
      if (card.__color == null && ci > -1) {
        /* the colour on show is the one whose photo the card is showing */
        var img = card.querySelector('.product-card__img'), cur = img ? fileOf(img.currentSrc || img.src) : '';
        var hit = p.variants.filter(function (v) { return v.featured_image && fileOf(v.featured_image.src) === cur; })[0];
        card.__color = (hit || p.variants[0]).options[ci];
      }
      var list = p.variants.filter(function (v) { return ci < 0 || v.options[ci] === card.__color; });
      var panel = media.querySelector('.pc-quick');
      if (!panel) { panel = document.createElement('div'); panel.className = 'pc-quick'; media.appendChild(panel); }
      if (list.length > 1) {
        panel.innerHTML = '<span class="pc-quick__label">Quick add</span><div class="pc-quick__sizes">' + list.map(function (v) {
          var label = v.options.filter(function (x, i) { return i !== ci; }).join(' / ').split('/US')[0].split('/ US')[0].split('(')[0].trim();
          return '<button type="button" class="pc-quick__size" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + ' aria-label="Add size ' + esc(label) + ' to bag">' + esc(label) + '</button>';
        }).join('') + '</div>';
      } else {
        panel.innerHTML = '<button type="button" class="pc-quick__add" data-vid="' + (list[0] ? list[0].id : '') + '"' + (list[0] && list[0].available ? '' : ' disabled') + '>Add to bag</button>';
      }
    }
    function prime(card) {
      if (card.__primed) return;
      var btn = card.querySelector('[data-quick-add]'); if (!btn) return;
      card.__primed = true;
      fetch(btn.getAttribute('data-quick-add') + '.js')
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (p) { card.__p = p; build(card); })
        .catch(function () { card.__primed = false; });
    }
    function pick(dot) {
      var card = dot.closest('.product-card'); if (!card || card.__color === dot.getAttribute('data-color')) return;
      card.__color = dot.getAttribute('data-color');
      slice(card.querySelectorAll('.product-card__dot')).forEach(function (d) { d.classList.toggle('is-on', d === dot); });
      var src = dot.getAttribute('data-img'), img = card.querySelector('.product-card__img');
      if (src && img) {
        img.srcset = [300, 450, 600, 900].map(function (w) { return uncropped(src, w) + ' ' + w + 'w'; }).join(', ');
        img.src = src; card.classList.add('is-swapped');
      }
      if (card.__p) build(card); else prime(card);
    }
    document.addEventListener('mouseover', function (e) {
      if (!e.target.closest) return;
      var dot = e.target.closest('.product-card__dot[data-color]'); if (dot) pick(dot);
      var card = e.target.closest('.product-card'); if (card) prime(card);
    });
    document.addEventListener('focusin', function (e) { var card = e.target.closest && e.target.closest('.product-card'); if (card) prime(card); });
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('.product-card__dot[data-color]');
      if (dot) { e.preventDefault(); pick(dot); return; }
      var b = e.target.closest('.pc-quick [data-vid]'); if (!b) return;
      e.preventDefault();
      var panel = b.closest('.pc-quick'); if (panel.classList.contains('is-busy')) return;
      panel.classList.add('is-busy'); panel.classList.remove('has-msg'); b.classList.add('is-loading');
      opener = b;
      cartPost('/cart/add.js', { items: [{ id: +b.getAttribute('data-vid'), quantity: 1 }], sections: cartSections(), sections_url: location.pathname })
        .then(function (res) {
          if (!res.ok || !res.data) throw res;
          renderCart(res.data.sections); open('cart');
          panel.classList.add('is-added'); setTimeout(function () { panel.classList.remove('is-added'); }, 2400);
        })
        .catch(function (res) {
          var msg = res && res.data && (res.data.description || res.data.message);
          panel.setAttribute('data-msg', typeof msg === 'string' && msg ? msg : ADD_FAILED);
          panel.classList.add('has-msg'); setTimeout(function () { panel.classList.remove('has-msg'); }, 4500);
        })
        .then(function () { panel.classList.remove('is-busy'); b.classList.remove('is-loading'); });
    });
  }

  /* Second (hover) card image: fetched the first time the pointer reaches its card, in the size the
     card shows; never on touch screens, and never during page load */
  var hoverReady = false;
  function hoverImages() {
    if (hoverReady || !window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    hoverReady = true;
    var load = function (e) {
      var card = e.target.closest && e.target.closest('.product-card'); if (!card) return;
      var im = card.querySelector('img[data-hover-src]'); if (!im) return;
      var src = im.getAttribute('data-hover-src'), main = card.querySelector('.product-card__img');
      im.removeAttribute('data-hover-src'); im.loading = 'eager'; im.hidden = false;
      if (main && main.sizes) { im.sizes = main.sizes; im.srcset = [300, 360, 450, 600, 750, 900].map(function (w) { return uncropped(src, w) + ' ' + w + 'w'; }).join(', '); }
      im.src = src;
    };
    document.addEventListener('mouseover', load, { passive: true });
    document.addEventListener('focusin', load);
  }
  /* A page served from a prefetch or the back/forward cache may carry an old bag */
  function keepCartFresh() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.deliveryType === 'navigational-prefetch') refreshCart();
    } catch (e) {}
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  }

  /* Announcement bar: the messages only start rotating once the page has loaded */
  function announce() {
    var bar = document.querySelector('.announce'); if (!bar) return;
    var go = function () { setTimeout(function () { bar.classList.add('is-rolling'); }, 1800); };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }

  /* Start-up in short steps: what the first screen needs runs now, the rest when the browser has a
     free moment, so no single step holds up a tap or the first paint */
  function later(fn) { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 1500 }); else setTimeout(fn, 60); }
  function init() {
    headerScroll(); gallery();
    document.querySelectorAll('[data-po]').forEach(initOptions);
    stickyAtc(); shop(); initSearch(); syncTiers(bagCount());
    later(function () { keepCartFresh(); hoverImages(); cards(); announce(); });
    later(function () { completeLook(); styledWith(); productRecs(); recentlyViewed(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
